import { AppDispatch } from '@/store/store';
import {
  dispatchReaderAction,
  ReaderWidgetTriggerContext,
} from '@/actions/ReaderActionCreator';
import {
  dispatchWidgetAction,
  WidgetTriggerContext,
} from '@/actions/WidgetTriggerActionCreators';
import { MessageId } from '@/models/Message';
import { searchStringToObj } from '@/utils/routerUtils';

export enum Trigger {
  READER = 'reader',
  WIDGET = 'widget',
}

type TriggerContext = ReaderWidgetTriggerContext | WidgetTriggerContext;

export function checkAndDispatchTriggersFromQueryString(
  qs: string,
  dispatch: AppDispatch,
): void {
  // Pull trigger and context from query string
  const {
    trigger: rawTriggerId,
    trigger_context: rawTriggerContext,
    message_id: messageId,
  } = searchStringToObj(qs);

  // validate trigger is valid
  const triggerId = rawTriggerId ? getTriggerId(rawTriggerId as string) : null;
  if (!triggerId) {
    return;
  }

  let triggerContextObj;
  try {
    triggerContextObj = rawTriggerContext
      ? JSON.parse(rawTriggerContext as string)
      : {};
  } catch (error) {
    console.log('failed to parse the trigger context', error);
    return;
  }

  dispatchTriggerAction({
    messageId: messageId as string,
    triggerId,
    triggerContextObj,
    dispatch,
  });
}

export function getTriggerId(triggerId: string): Trigger | null {
  const trigger = Trigger[triggerId.toUpperCase() as keyof typeof Trigger];

  if (!trigger) {
    console.log(`triggerId is unsupported [trigger=${triggerId}]`);
    return null;
  }

  return trigger;
}

export function dispatchTriggerAction({
  messageId,
  triggerId,
  triggerContextObj,
  dispatch,
}: {
  messageId?: MessageId;
  triggerId: Trigger;
  triggerContextObj: TriggerContext;
  dispatch: AppDispatch;
}): void {
  switch (triggerId) {
    case Trigger.READER: {
      const readerTrigger = triggerContextObj as ReaderWidgetTriggerContext;
      dispatchReaderAction({
        messageId: messageId,
        triggerContextObj: readerTrigger,
        dispatch: dispatch,
      });
      break;
    }
    case Trigger.WIDGET: {
      const widgetTrigger = triggerContextObj as WidgetTriggerContext;
      dispatchWidgetAction({
        messageId: messageId,
        triggerContextObj: widgetTrigger,
        dispatch: dispatch,
      });
      break;
    }
  }
}
